import {
  cameraPosition,
  float,
  Fn,
  length,
  mix,
  positionWorld,
  smoothstep,
  vec3,
} from "three/tsl"
import * as THREE from "three/webgpu"
import { FolderApi } from "tweakpane"

export default class Floor {
  scene: THREE.Scene
  debugFolder?: FolderApi
  color: THREE.TSL.ShaderNodeObject<THREE.UniformNode<THREE.Color>>

  constructor({
    scene,
    debugFolder,
    color,
  }: {
    scene: THREE.Scene
    debugFolder?: FolderApi
    color: THREE.TSL.ShaderNodeObject<THREE.UniformNode<THREE.Color>>
  }) {
    this.scene = scene
    this.debugFolder = debugFolder

    this.color = color

    this.setMesh()
  }

  setMesh() {
    const geometry = new THREE.PlaneGeometry(100, 100)
    const material = new THREE.MeshBasicNodeMaterial()

    material.colorNode = Fn(() => {
      // Distance from camera
      const distanceFromCamera = length(positionWorld.sub(cameraPosition))

      const gradientFactor = smoothstep(float(1), float(10), distanceFromCamera)

      const black = vec3(0)
      return mix(this.color, black, gradientFactor)
    })()

    const mesh = new THREE.Mesh(geometry, material)

    mesh.rotation.x = -Math.PI / 2
    mesh.renderOrder = -1

    this.scene.add(mesh)
  }
}
